import React from "react";
import "./Footer.css";
import logo from "../assets/MAD - Dark 1.png";
import insta from "../assets/Instagram_Icon.png";
import linkedln from "../assets/LinkedIn_Icon.png";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-left">
                {/* Link to Instagram */}
                <a
                    href="https://www.instagram.com/micahalysedesign/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={insta} alt="Instagram Icon" className="social-icon" />
                </a>

                {/* Link to LinkedIn */}
                <a
                    href="https://www.linkedin.com/in/micahfriedberg/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={linkedln} alt="LinkedIn Icon" className="social-icon" />
                </a>
            </div>
            <div className="footer-center">
                <p>
                    Micah Alyse Design <br />
                    ©2018 <br />
                    micahalyse@gmail.com
                </p>
            </div>
            <div className="footer-right">
                <img src={logo} alt="Micah Alyse Design Logo" className="footer-logo" />
            </div>
        </footer>
    );
};

export default Footer;
